import { Button, Modal } from '@insurancemenu/imenu-components-lib';
import FormsSpinner from 'components/common/general/FormSpinner';
import React, { useRef } from 'react';
import { createStyles } from './styles';

export interface FilterModal {
  show: boolean;
  onClose: () => void;
  loading: boolean;
  filter: JSX.Element;
}

const FilterModal = ({ show, filter, onClose, loading }: FilterModal): JSX.Element => {
  const classes = createStyles();
  const scrollRef = useRef<HTMLDivElement>(null);

  const onModalClose = (): void => {
    scrollRef.current?.scrollTo(0, 0);
    onClose();
  };

  return (
    <Modal show={show} onClose={onModalClose} closable className={classes.modal} modalContainerRef={scrollRef}>
      {loading ? (
        <FormsSpinner display={loading} />
      ) : (
        <>
          {filter}
          <footer className={classes.modalFooter}>
            <Button type="outlined" onClick={onModalClose} size="large" color="primary">
              Close
            </Button>
          </footer>
        </>
      )}
    </Modal>
  );
};

export default FilterModal;
